import { l10n } from '@ott/l10n';

export const fieldsNames = {
  id: 'id',
  cardNumber: 'cardNumber',
  cardHolder: 'cardHolder',
  cvv: 'cardCVV',
  month: 'expMonth',
  year: 'expYear',
  saveCard: 'saveCard',
} as const;

export const defaultValues = {
  [fieldsNames.cardNumber]: '',
  [fieldsNames.cardHolder]: '',
  [fieldsNames.cvv]: '',
  [fieldsNames.month]: '',
  [fieldsNames.year]: '',
  [fieldsNames.saveCard]: true,
};

export const dataLocators = {
  root: 'credit-card',
  cardNumber: 'credit-card__card-number',
  month: 'credit-card__month',
  year: 'credit-card__year',
  cvv: 'credit-card__cvv',
  cardHolder: 'credit-card__cardholder-name',
  saveCard: 'save-card-data',
};

export const cardBinLength = 6;
export const minCVVLength = 3;
export const maxCVVLength = 4;

export const maskDot = '\u2022';

export const newCardOption = {
  value: 'NEW_CARD',
  label: l10n('paymentCardNew.dropDownButtonText'),
};
